import React, { memo, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import CustomButton from './CustomButton';
import withRoutingProps from '../../hooks/withRoutingProps';

const ConfirmationModal = ({
  isOpen,
  modalTitle = undefined,
  closeClick,
  saveClick,
  modalClick = undefined,
  modalSize = 'sm',
  modalScrollable = false,
  modalBackDrop = undefined,
  isCentered = false,
  modalHeaderClassName = undefined,
  // Save Button
  isSaveButtonVisible = true,
  submitButtonName = 'Save',
  isCloseButtonVisible = true,
  closeButtonName = 'Close',
  saveButtonClassName = undefined,

  modalOnOpened = undefined,
  modalOnClosed = undefined,
  modalClassName = undefined,
  modalStyle = undefined,
  modalKeyboard = undefined,
  bodyClassName = undefined,
  bodyStyle = undefined,
  extraFooterChildren = undefined,
  isFooterVisible = true,
  isHeaderVisible = true,

  isLightTheme,
  showTextConfirm = false,
  textClassName = undefined,
  confirmTextClassName = undefined,
  confirmText = '',
  caseSensitive = true,
  message = '',
  closeButtonClassName = undefined
}) => {
  const [inputValue, setInputValue] = useState('');

  const isTextMatched = !showTextConfirm
    ? true
    : caseSensitive
      ? inputValue === confirmText
      : inputValue.toLowerCase() === confirmText.toLowerCase();

  return (
    <Modal
      isOpen={isOpen}
      toggle={closeClick}
      backdrop={modalBackDrop}
      centered={isCentered}
      size={modalSize}
      scrollable={modalScrollable}
      className={` ${modalClassName || ''}`}
      backdropClassName={`${isLightTheme ? 'modal-backdrop-light' : 'modal-backdrop-dark'}`}
      style={modalStyle}
      keyboard={modalKeyboard}
      onOpened={() => {
        modalOnOpened && modalOnOpened();
      }}
      onClosed={() => {
        modalOnClosed && modalOnClosed();
      }}
      onClick={modalClick}
    >
      {isHeaderVisible && <ModalHeader className={modalHeaderClassName}>{modalTitle}</ModalHeader>}
      <ModalBody className={bodyClassName} style={bodyStyle}>
        <div className={textClassName}>{message}</div>

        {showTextConfirm && (
          <div className="mt-2 mb-2">
            <div className={`mb-1 ${confirmTextClassName}`}>
              Please type <strong>{confirmText}</strong> to confirm.
            </div>
            <input
              type="text"
              className="form-control"
              value={inputValue}
              onChange={e => setInputValue(e.target.value)}
              placeholder={`Type "${confirmText}"`}
              autoFocus
            />
          </div>
        )}
      </ModalBody>
      {isFooterVisible && (
        <ModalFooter>
          {extraFooterChildren ? extraFooterChildren : undefined}
          {isSaveButtonVisible ? (
            <CustomButton
              outline
              type="submit"
              color="primary"
              className={saveButtonClassName}
              disabled={!isTextMatched}
              onClick={() => {
                if (saveClick) {
                  saveClick();
                }
              }}
            >
              {submitButtonName}
            </CustomButton>
          ) : (
            ''
          )}
          {isCloseButtonVisible && (
            <CustomButton outline type="reset" className={closeButtonClassName} onClick={closeClick}>
              {closeButtonName}
            </CustomButton>
          )}
        </ModalFooter>
      )}
    </Modal>
  );
};

ConfirmationModal.displayName = 'ConfirmationModal';
export default memo(withRoutingProps(ConfirmationModal));
